(function(){
  if (window.__bkz3) return; window.__bkz3 = true;
  var R = window.bkzRoutes || { add: '/cart/add', cart: '/cart', cartJs: '/cart.js' };
  function money(c){ var f = R.money || '₹{{amount_no_decimals}}', n = c / 100, a0 = Math.round(n).toLocaleString('en-IN'), a2 = n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); return f.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){ return (k === 'amount_no_decimals' || c % 100 === 0) ? a0 : a2; }); }
  function $(s, r){ return (r || document).querySelector(s); }
  function $$(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- cart + toast ---------- */
  var toastEl, toastTimer;
  function toast(item){
    if (!toastEl){
      toastEl = document.createElement('div'); toastEl.className = 'bkz-toast'; toastEl.setAttribute('role','status');
      document.body.appendChild(toastEl);
    }
    var img = item && item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '';
    toastEl.innerHTML = img + '<div class="z-tt"><b>Added to bag!</b>' + (item ? (item.product_title || '') : '') + '</div><a href="' + R.cart + '">View bag</a><button class="z-tx" type="button" aria-label="Close">✕</button>';
    toastEl.querySelector('.z-tx').onclick = function(){ toastEl.classList.remove('z-show'); };
    requestAnimationFrame(function(){ toastEl.classList.add('z-show'); });
    clearTimeout(toastTimer); toastTimer = setTimeout(function(){ toastEl.classList.remove('z-show'); }, 5000);
  }
  function refreshCount(){
    fetch(R.cartJs, { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(function(c){
      $$('.cart-count-bubble span[aria-hidden="true"]').forEach(function(s){ s.textContent = c.item_count; });
      if (!$('.cart-count-bubble')) $$('[id^="cart-icon-bubble"]').forEach(function(b){
        var s = document.createElement('span'); s.className = 'cart-count-bubble'; s.innerHTML = '<span aria-hidden="true">' + c.item_count + '</span>'; b.appendChild(s);
      });
      document.dispatchEvent(new CustomEvent('bkz:cart', { detail: c }));
    }).catch(function(){});
  }
  function addItems(items){
    return fetch(R.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(j){ var it = j.items ? j.items[0] : j; var dr = openDrawer(true); if (!dr) toast(it); refreshCount(); try { j.__drawer = dr; } catch(_){} return j; });
  }
  window.bkzAdd = addItems;

  /* slide-out cart drawer: opens instantly, loads the theme drawer on demand, refreshes only when the cart changed */
  function drawerEl(){ var d = $('cart-drawer'); return d && typeof d.show === 'function' ? d : null; }
  function wake(){ try { var c = window.lazyTemplateController; if (c && !c.userFirstInteraction && c.triggerOnce) c.triggerOnce(); } catch(_){} }
  function findDrawer(n){ var q = n.querySelector('cart-drawer'); if (q) return q; var ts = n.querySelectorAll('template'); for (var i = 0; i < ts.length; i++) { var r = findDrawer(ts[i].content); if (r) return r; } return null; }
  function refreshDrawer(d){
    if (window.cartBase && cartBase.refreshCart) return Promise.resolve(cartBase.refreshCart()).catch(function(){});
    var sec = d.closest('[id^="shopify-section-"]'); if (!sec) return Promise.resolve();
    var id = sec.id.replace('shopify-section-', '');
    return fetch(location.pathname + '?sections=' + encodeURIComponent(id)).then(function(r){ return r.json(); }).then(function(j){
      var t = document.createElement('div'); t.innerHTML = j[id] || ''; var n = findDrawer(t); if (!n) return;
      d.classList.toggle('is-empty', n.classList.contains('is-empty')); d.innerHTML = n.innerHTML;
    }).catch(function(){});
  }
  function openDrawer(refresh){
    refresh = refresh !== false;
    if (/^\/cart\/?$/.test(location.pathname)) return false;
    var icon = $('.bkz-head .z-hd-cart') || $('.z-hd-cart'), t0 = Date.now();
    wake(); if (icon) icon.setAttribute('aria-busy', 'true');
    var done = function(){ if (icon) icon.removeAttribute('aria-busy'); };
    (function wait(){
      var d = drawerEl();
      if (d) {
        var go = function(){ done(); d.show(icon); };
        if (refresh) refreshDrawer(d).then(go, go); else go();
      } else if (Date.now() - t0 < (refresh ? 4000 : 2500)) { setTimeout(wait, 50); }
      else { done(); if (refresh) toast(null); else location.href = R.cart; }
    })();
    return true;
  }
  window.bkzOpenCart = openDrawer;
  /* a11y: name third-party iframes */
  function nameFrames(){ $$('iframe:not([title])').forEach(function(f){ var k = (f.id || '') + ' ' + (f.src || ''); if (/bwa|amazon/i.test(k)) f.title = 'Buy with Amazon delivery details'; else if (/youtube|vimeo/i.test(k)) f.title = 'Video'; }); }
  [800, 2500, 6000].forEach(function(t){ setTimeout(nameFrames, t); });
  document.addEventListener('bkz:cart', function(){ setTimeout(nameFrames, 1500); });
  /* warm the theme's deferred cart scripts once the page is idle, so the first tap on the bag opens instantly */
  function idleWake(){ (window.requestIdleCallback || function(f){ setTimeout(f, 1); })(wake, { timeout: 2000 }); }
  if (document.readyState === 'complete') setTimeout(idleWake, 2500); else window.addEventListener('load', function(){ setTimeout(idleWake, 2500); });
  (function(){ var st = document.createElement('style'); st.textContent = '.bkz-head .z-hd-cart[aria-busy=true]{animation:bkzBusy .8s ease-in-out infinite alternate}@keyframes bkzBusy{to{transform:scale(.88);opacity:.7}}@media (prefers-reduced-motion:reduce){.bkz-head .z-hd-cart[aria-busy=true]{animation:none;opacity:.7}}'; document.head.appendChild(st); })();
  ['pointerover', 'touchstart', 'focusin'].forEach(function(ev){
    document.addEventListener(ev, function(e){ if (e.target.closest && e.target.closest('.bkz-head .z-hd-cart')) wake(); }, { passive: true });
  });
  document.addEventListener('click', function(e){
    var a = e.target.closest('.bkz-head .z-hd-cart'); if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (openDrawer(false)) e.preventDefault();
  });

  /* quick add on cards */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-quick-add]'); if (!b || b.disabled) return;
    e.preventDefault(); b.classList.add('z-busy');
    addItems([{ id: +b.getAttribute('data-quick-add'), quantity: 1 }])
      .then(function(){ b.classList.remove('z-busy'); b.classList.add('z-done'); setTimeout(function(){ b.classList.remove('z-done'); }, 1500); })
      .catch(function(err){ b.classList.remove('z-busy'); alertMsg(err); });
  });
  function alertMsg(err){ var m = (err && (err.description || err.message)) || 'Could not add to bag. Please try again!'; toastErr(m); }
  function toastErr(m){ toast(null); toastEl.querySelector('.z-tt').innerHTML = '<b>Oops!</b>' + m; }

  /* ---------- homepage: spirit + pack ---------- */
  function initSpirit(root){
    var chips = root.querySelectorAll('.z-chip'), panes = root.querySelectorAll('.z-pane');
    chips.forEach(function(c){ c.addEventListener('click', function(){
      var i = c.getAttribute('data-i');
      chips.forEach(function(x){ x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      panes.forEach(function(p){ p.classList.toggle('z-on', p.getAttribute('data-i') === i); });
    }); });
  }
  function initPack(root){
    var need = +root.dataset.need || 3, pct = +root.dataset.pct || 0, pack = [];
    var slots = root.querySelectorAll('.z-slot'), msg = root.querySelector('[data-msg]'), fill = root.querySelector('[data-fill]'),
        total = root.querySelector('[data-total]'), save = root.querySelector('[data-save]'), addBtn = root.querySelector('[data-addpack]'),
        note = save.textContent;
    function sel(card){ var s = card.querySelector('select.z-size') || card.querySelector('input[name=id]');
      var opt = s.tagName === 'SELECT' ? s.options[s.selectedIndex] : s; return { id: s.value, price: +opt.getAttribute('data-price') }; }
    function render(){
      var sum = 0;
      slots.forEach(function(sl, i){ var p = pack[i]; sl.classList.toggle('z-full', !!p);
        sl.innerHTML = p ? '<img src="' + p.img + '" alt="' + p.name + '">' : String(i + 1); });
      pack.forEach(function(p){ var v = sel(p.card); p.id = v.id; sum += v.price; });
      var n = pack.length, full = n >= need, tot = full ? Math.round(sum * (100 - pct) / 100) : sum;
      msg.textContent = full ? 'Pack complete! ' + pct + '% off unlocked.' : (need - n) + ' more pair' + (need - n === 1 ? '' : 's') + ' to unlock ' + pct + '% off';
      fill.style.width = Math.round(Math.min(n, need) / need * 100) + '%'; fill.classList.toggle('z-done', full);
      total.textContent = money(tot); save.textContent = full ? 'You save ' + money(sum - tot) + ' (applied at checkout)' : note;
      addBtn.disabled = n === 0;
      root.querySelectorAll('[data-card]').forEach(function(card){
        var on = pack.some(function(p){ return p.card === card; }), b = card.querySelector('[data-toggle]');
        b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.textContent = on ? '✓ In your pack' : '+ Add to pack'; });
    }
    root.querySelectorAll('[data-card]').forEach(function(card){
      card.querySelector('[data-toggle]').addEventListener('click', function(){
        var i = pack.findIndex(function(p){ return p.card === card; });
        if (i >= 0) pack.splice(i, 1); else { if (pack.length >= need) pack.shift();
          pack.push({ card: card, img: card.dataset.img, name: card.dataset.name }); }
        render(); });
      var s = card.querySelector('select.z-size'); if (s) s.addEventListener('change', render);
    });
    addBtn.addEventListener('click', function(){
      if (!pack.length) return; addBtn.disabled = true; addBtn.textContent = 'Adding…';
      var counts = {}; pack.forEach(function(p){ counts[p.id] = (counts[p.id] || 0) + 1; });
      var items = Object.keys(counts).map(function(id){ return { id: +id, quantity: counts[id] }; });
      addItems(items).then(function(j){ if (j && j.__drawer) { addBtn.disabled = false; addBtn.textContent = 'Add pack to bag'; } else { window.location.href = R.cart; } })
        .catch(function(){ addBtn.disabled = false; addBtn.textContent = 'Add pack to bag'; msg.textContent = 'Something went wrong. Please try again!'; });
    });
    render();
  }

  /* ---------- product page ---------- */
  function initPdp(root){
    var form = root.querySelector('[data-pdp-form]'); if (!form) return;
    var variants = JSON.parse((root.querySelector('[data-variants]') || {}).textContent || '[]');
    var vid = form.querySelector('[data-vid]'), atc = form.querySelector('[data-atc]'), lbl = form.querySelector('[data-atc-label]');
    var pEl = root.querySelector('[data-p]'), cEl = root.querySelector('[data-c]'), oEl = root.querySelector('[data-o]'), sp = root.querySelector('[data-sp]');
    function selected(){ var o = []; $$('input[data-opt]:checked', form).forEach(function(i){ o[+i.dataset.opt] = i.value; }); return o; }
    function find(opts){ return variants.find(function(v){ return v.options.every(function(x, i){ return opts[i] === undefined || x === opts[i]; }); }); }
    function markAvail(){
      var cur = selected();
      $$('input[data-opt]', form).forEach(function(inp){
        var test = cur.slice(); test[+inp.dataset.opt] = inp.value; var v = find(test);
        var l = form.querySelector('label[for="' + inp.id + '"]'); if (l) l.classList.toggle('z-na', !v || !v.available);
      });
    }
    function update(){
      var v = find(selected()); if (!v) return;
      vid.value = v.id;
      pEl.textContent = money(v.price); if (sp) sp.textContent = money(v.price);
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      cEl.hidden = !sale; oEl.hidden = !sale;
      if (sale){ cEl.textContent = money(v.compare_at_price); oEl.textContent = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off'; }
      atc.disabled = !v.available; lbl.textContent = v.available ? 'Add to bag' : 'Sold out';
      try { history.replaceState(null, '', '?variant=' + v.id); } catch(e){}
      if (v.featured_media){ var fig = root.querySelector('[data-media-id="' + v.featured_media.id + '"]'); var g = root.querySelector('[data-gal]'); if (fig && g && g.scrollWidth > g.clientWidth + 5) g.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' }); }
      markAvail();
    }
    form.addEventListener('change', function(e){ if (e.target.matches('input[data-opt]')) update(); });
    markAvail();
    var q = form.querySelector('[data-qty]');
    $$('[data-q]', form).forEach(function(b){ b.addEventListener('click', function(){ q.value = Math.max(1, (+q.value || 1) + (+b.dataset.q)); }); });
    form.addEventListener('submit', function(e){
      if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
      e.preventDefault(); if (atc.disabled) return;
      atc.disabled = true; var old = lbl.textContent; lbl.textContent = 'Adding…';
      addItems([{ id: +vid.value, quantity: Math.max(1, +q.value || 1) }])
        .then(function(){ lbl.textContent = 'Added!'; setTimeout(function(){ lbl.textContent = old; atc.disabled = false; }, 1400); })
        .catch(function(err){ lbl.textContent = old; atc.disabled = false; alertMsg(err); });
    });
    /* gallery dots */
    var g = root.querySelector('[data-gal]'), dots = $$('.z-dot', root), gi = root.querySelector('[data-gal-i]');
    if (g && dots.length){ g.addEventListener('scroll', function(){ var i = Math.round(g.scrollLeft / g.clientWidth); dots.forEach(function(d, k){ d.classList.toggle('z-on', k === i); }); if (gi) gi.textContent = i + 1; }, { passive: true }); }
    /* sticky bar */
    var st = root.querySelector('[data-sticky]');
    if (st && 'IntersectionObserver' in window){
      new IntersectionObserver(function(en){ var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; st.classList.toggle('z-show', show); st.setAttribute('aria-hidden', show ? 'false' : 'true'); root.querySelector('[data-sticky-btn]').tabIndex = show ? 0 : -1; }).observe(atc);
      root.querySelector('[data-sticky-btn]').addEventListener('click', function(){
        if (atc.disabled){ atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }
  }

  /* ---------- recommendations ---------- */
  function initRecs(root){
    if (root.querySelector('.bkz-pc')) return;
    fetch(root.dataset.url).then(function(r){ return r.text(); }).then(function(h){
      var d = document.createElement('div'); d.innerHTML = h; var n = d.querySelector('[data-bkz-recs]'); if (n && n.innerHTML.trim()) root.innerHTML = n.innerHTML;
    }).catch(function(){});
  }

  /* ---------- collection ---------- */
  function initCol(root){
    var dr = root.querySelector('[data-filters]'), ob = root.querySelector('[data-open-filters]');
    function open(o){ dr.hidden = !o; ob.setAttribute('aria-expanded', o ? 'true' : 'false'); document.documentElement.style.overflow = o ? 'hidden' : ''; if (o){ var f = dr.querySelector('button'); if (f) f.focus(); } else ob.focus(); }
    if (dr && ob){ ob.addEventListener('click', function(){ open(true); }); $$('[data-close-filters]', dr).forEach(function(b){ b.addEventListener('click', function(){ open(false); }); }); dr.addEventListener('keydown', function(e){ if (e.key === 'Escape') open(false); }); }
    var s = root.querySelector('[data-sort]'); if (s) s.addEventListener('change', function(){ s.form.submit(); });
  }
  document.addEventListener('click', function(e){
    var m = e.target.closest('[data-more]'); if (!m) return; e.preventDefault();
    var grid = m.closest('.z-wrap').querySelector('.z-grid-p'); m.textContent = 'Loading…';
    fetch(m.href).then(function(r){ return r.text(); }).then(function(h){
      var d = document.createElement('div'); d.innerHTML = h;
      var ng = d.querySelector('.z-grid-p'); if (ng) $$('.bkz-pc, .z-sres', ng).forEach(function(c){ grid.appendChild(c); });
      var nm = d.querySelector('.z-more'), om = m.closest('.z-more');
      if (nm) om.replaceWith(nm); else om.remove();
      try { history.replaceState(null, '', m.href); } catch(e){}
    }).catch(function(){ window.location.href = m.href; });
  });

  function boot(scope){
    var s = scope || document;
    $$('[data-bkz-spirit]', s).forEach(initSpirit); $$('[data-bkz-pack]', s).forEach(initPack);
    $$('[data-bkz-pdp]', s).forEach(initPdp); $$('[data-bkz-recs]', s).forEach(initRecs); $$('[data-bkz-col]', s).forEach(initCol);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); }); else boot();
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
